import {Component, Input, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {RouterLink} from '@angular/router';
import {DashboardTitleService} from '../../../services/dashboard-title.service';
import {DateTime} from 'luxon';

@Component({
  selector: 'app-breadcrumbs',
  imports: [
    RouterLink
  ],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
})
export class BreadcrumbsComponent {

  @Input() set breadcrumbItems(value: MenuItem[]){
    this._breadcrumbItems=value;
  }
  protected _breadcrumbItems!: MenuItem[];

  constructor() {
  }

  getDate(date: DateTime) {
    return date.toLocaleString({day: '2-digit', month: '2-digit', year: 'numeric'});
  }

}
